/**
 * The "Add to surgery waitlist" dialog, opened from the Surgery Waitlist. It works out who the entry is for -
 * the open patient, or one found with the calendar's patient search - and hosts the add form, which saves it.
 * Resolves with the new entry's id.
 */
app.controller("surgeryWaitlistAddDialogController", [
	"$scope",
	"$mdDialog",
	"$timeout",
	"Session",
	"PatientAPI",
	"PatientImportReview",
	"patient",
	function ($scope, $mdDialog, $timeout, Session, PatientAPI, PatientImportReview, patient) {
		$scope.$mdDialog = $mdDialog;

		// { id, name, dob } of who the entry is for; null until one is chosen
		$scope.waitlistPatient = patient;
		$scope.pickingPatient = !patient;
		$scope.patientPicker = { query: "", open: false, active: -1 };
		$scope.patientSearch = { results: [], searched: false, loading: false };

		$scope.onAdded = function (surgeryWaitlist) {
			$mdDialog.hide(surgeryWaitlist && surgeryWaitlist.surgery_waitlist_id);
		};

		$scope.cancel = function () {
			$mdDialog.cancel();
		};

		// =================================================================
		// Finding the patient: the patient search the calendar and New Task use (surname, phone, email or NHI).
		// An entry can only be added at the practice the patient is registered at, so another practice's
		// patients are shown but can't be chosen.
		// =================================================================
		let patientSearchSequence = 0;
		let patientListCloseTimer = null;

		function toChoice(p) {
			const born = p.dateOfBirth && moment(p.dateOfBirth).isValid() ? moment(p.dateOfBirth).locale("en") : null;
			return {
				id: p.id,
				name: [p.firstName, p.lastName].filter(Boolean).join(" "),
				dob: born ? born.format("DD/MM/YYYY") : "",
				dobLabel: born ? born.format("D MMM YYYY") : "",
				otherPractice: p.practice && p.practice.id !== Session.practice.id ? p.practice.name || "Another practice" : null,
				needsReview: !!p.needs_review,
			};
		}

		function searchPatients(term) {
			const searchTerm = (term || "").trim();
			const requestId = ++patientSearchSequence;
			if (searchTerm.length < 2) {
				$scope.patientSearch = { results: [], searched: false, loading: false };
				return;
			}
			$scope.patientSearch.loading = true;
			PatientAPI.search("", "", searchTerm, "").then(
				function (resp) {
					if (requestId !== patientSearchSequence) {
						return;
					}
					$scope.patientPicker.active = -1;
					$scope.patientSearch = { searched: true, loading: false, results: (resp.data || []).map(toChoice) };
				},
				function () {
					if (requestId === patientSearchSequence) {
						$scope.patientSearch = { results: [], searched: true, loading: false };
					}
				}
			);
		}

		$scope.isPatientListOpen = function () {
			return $scope.patientPicker.open && ($scope.patientPicker.query || "").trim().length >= 2
				&& ($scope.patientSearch.loading || $scope.patientSearch.searched);
		};

		// Typing again is a new search: whoever was chosen no longer matches what the field says.
		$scope.onPatientQueryChange = function () {
			$scope.waitlistPatient = null;
			$scope.patientPicker.open = true;
			searchPatients($scope.patientPicker.query);
		};

		// Escape with the list open closes only the list, not the whole dialog
		$scope.onPatientKeydown = function (event) {
			const results = $scope.patientSearch.results;
			if (event.key === "ArrowDown" || event.key === "ArrowUp") {
				event.preventDefault();
				if (!results.length) {
					return;
				}
				$scope.patientPicker.open = true;
				const step = event.key === "ArrowDown" ? 1 : -1;
				$scope.patientPicker.active = ($scope.patientPicker.active + step + results.length) % results.length;
			} else if (event.key === "Enter") {
				event.preventDefault();
				if ($scope.isPatientListOpen() && results[$scope.patientPicker.active]) {
					$scope.choosePatient(results[$scope.patientPicker.active]);
				}
			} else if (event.key === "Escape" && $scope.isPatientListOpen()) {
				event.preventDefault();
				event.stopPropagation();
				$scope.patientPicker.open = false;
			}
		};

		// After a moment, so a click on a result (handled on mousedown) is not lost to the blur.
		$scope.closePatientList = function () {
			$timeout.cancel(patientListCloseTimer);
			patientListCloseTimer = $timeout(function () {
				$scope.patientPicker.open = false;
			}, 150);
		};

		$scope.choosePatient = function (choice) {
			if (choice.otherPractice) {
				return;
			}
			if (choice.needsReview) {
				// An imported patient is reviewed before anything is added for them; carry on with the patient it
				// turns out to be - the existing patient, when it was a duplicate.
				$scope.patientPicker.open = false;
				PatientImportReview.open(choice.id)
					.then(function (reviewed) {
						$scope.choosePatient(toChoice(reviewed));
					})
					.catch(angular.noop);
				return;
			}
			$scope.waitlistPatient = { id: choice.id, name: choice.name, dob: choice.dob };
			// ng-change only fires for typing, so showing the name here does not search again
			$scope.patientPicker.query = choice.name;
			$scope.patientPicker.open = false;
			$scope.patientPicker.active = -1;
		};

		$scope.clearPatient = function () {
			$scope.waitlistPatient = null;
			$scope.patientPicker = { query: "", open: false, active: -1 };
			$scope.patientSearch = { results: [], searched: false, loading: false };
			patientSearchSequence++;
		};

		// Opened for a patient, the entry can still be for someone else
		$scope.changePatient = function () {
			$scope.clearPatient();
			$scope.pickingPatient = true;
			$scope.$$postDigest(() => {
				const field = document.getElementById("waitlistPatient");
				if (field) {
					field.focus();
				}
			});
		};

		$scope.$on("$destroy", () => $timeout.cancel(patientListCloseTimer));
	},
]);
